"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../utils");

var _SelectAllCheckbox = _interopRequireDefault(require("./SelectAllCheckbox"));

var HeaderRow = function HeaderRow(_ref) {
  var maxHeaderCount = _ref.maxHeaderCount,
      cells = _ref.cells,
      columns = _ref.columns,
      headerIndex = _ref.headerIndex;

  // If there is only one header row, return null and let the table handle
  if (maxHeaderCount <= 1) {
    return (0, _map["default"])(cells).call(cells, function (c, i) {
      return /*#__PURE__*/_react["default"].cloneElement(c, {
        children: columns[i].title === "__checkbox_selection__" ? /*#__PURE__*/_react["default"].createElement(_SelectAllCheckbox["default"], null) : c.props.children
      });
    });
  } // If this the last header row, stretch ophan columns


  if (headerIndex === maxHeaderCount - 1) {
    var count = 0;
    return (0, _map["default"])(cells).call(cells, function (c, i) {
      if (columns[i].parents.length === 0 && maxHeaderCount > 1) {
        var elem = /*#__PURE__*/_react["default"].cloneElement(c, {
          className: (0, _classnames["default"])(c.props.className, "".concat(_utils.CLASS_PREFIX, "__header-cell--orphan"), (0, _defineProperty2["default"])({}, "".concat(_utils.CLASS_PREFIX, "__header-cell--first-orphan"), count === 0)),
          children: columns[i].title === "__checkbox_selection__" ? /*#__PURE__*/_react["default"].createElement(_SelectAllCheckbox["default"], null) : c.props.children
        });

        count++;
        return elem;
      }

      count = 0;
      return c;
    });
  }

  var groupCells = (0, _map["default"])(columns).call(columns, function (_ref2, index) {
    var parents = _ref2.parents;
    var title = parents[headerIndex] || "__empty-header__";
    return {
      title: title,
      width: cells[index].props.style.width
    };
  });
  var mergedHeaderCells = (0, _utils.buildHeaderRow)(groupCells);
  return (0, _map["default"])(mergedHeaderCells).call(mergedHeaderCells, function (_ref3, index) {
    var _context;

    var title = _ref3.title,
        width = _ref3.width;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(_utils.CLASS_PREFIX, "__header-cell--parent"),
      key: (0, _concat["default"])(_context = "".concat(title, "-")).call(_context, index),
      style: {
        width: width
      }
    }, title === "__empty-header__" ? "" : title);
  });
};

var _default = HeaderRow;
exports["default"] = _default;